import React, { useState, useEffect } from 'react';
import { Select, Table } from 'antd';
// FormArchieveReadOnly - removed Button, Modal, Form, Input, Upload, message, Popconfirm, PlusOutlined
// import { Button, Modal, Form, Select, Input, Upload, Table, message, Popconfirm } from 'antd';
// import { PlusOutlined } from '@ant-design/icons';
// FormArchieveReadOnly - no longer fetching via DAL, data comes from redux store via props
// import Ratings from '../DAL/Ratings';
// import Icons from '../DAL/Icons';
import { actionData, dropdownDataFunc } from './actionsDataJSON';
// FormArchieveReadOnly - columnsFunc removed, using read-only columns below
// import { actionData, dropdownDataFunc, columnsFunc } from './actionsDataJSON';
// FormArchieveReadOnly - useSelector no longer needed, data passed as props
// import { useSelector } from 'react-redux';
// FormArchieveReadOnly - no firebase writes
// import { firebase } from '../utilities';

const { Option } = Select;

const readOnlyColumns = (selectedOption) => [
  {
    title: 'Image',
    dataIndex: 'image',
    key: 'image',
    render: (text) => (text ? <img src={text} alt="icon" style={{ width: '50px', height: '50px' }} /> : null),
    hidden: selectedOption !== 'Icon',
    width: '10%',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: '25%',
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    render: (text) => <div style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{text}</div>,
  },
].filter((col) => !col.hidden)

const ManageActionFields = ({ ratingsData, iconsData }) => {

  console.log('ManageActionFields - ratingsData:', ratingsData);
  console.log('ManageActionFields - iconsData:', iconsData);

  const [selectedOption, setSelectedOption] = useState('Cost');
  const [dataSource, setDataSource] = useState([]);

  const actionDataValues = actionData(ratingsData, iconsData);
  const dropdownData = dropdownDataFunc(actionDataValues);

  useEffect(() => {
    if (selectedOption.toLowerCase() === 'icon') {
      setDataSource([...iconsData].sort((a, b) => a.order - b.order));
    } else {
      setDataSource(
        ratingsData
          .filter((r) => r.type.toLowerCase() === selectedOption.toLowerCase())
          .sort((a, b) => a.order - b.order)
      );
    }
  }, [selectedOption, ratingsData, iconsData]);

  // FormArchieveReadOnly - removed: isAddModalVisible, image, itemName, description, editingItem,
  // orderedData, fetchData, handleCancel, handleAddIcon, handleAddRating, handleAdd,
  // handleImageUpload, isAddButtonDisabled, handleEditItem, handleUpdateItem, handleDeleteItem,
  // saveOrderToCollection, moveUp, moveDown

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
        <Select
          placeholder="Select Option"
          style={{ width: 200 }}
          onChange={setSelectedOption}
          value={selectedOption}
        >
          {dropdownData.map((ddD) => (
            <Option key={ddD.name} value={ddD.name}>
              {ddD.name}
            </Option>
          ))}
        </Select>
        {/* FormArchieveReadOnly - Add New button removed */}
      </div>
      <Table
        className="custom-table"
        columns={readOnlyColumns(selectedOption)}
        dataSource={dataSource}
        rowKey="id"
        style={{ backgroundColor: 'white' }}
        pagination={false}
      />
      {/* FormArchieveReadOnly - Add/Edit Modal removed */}
    </div>
  );
};

export { ManageActionFields };
